import { API_ENDPOINT_BUSINESS_TX } from '../config'
import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'
import { buildUrl } from '../utils/helpers'

export const E_SIGN_REQUEST = 'E_SIGN_REQUEST'
export const E_SIGN_SUCCESS = 'E_SIGN_SUCCESS'
export const E_SIGN_FAILURE = 'E_SIGN_FAILURE'

const buildDataUrl = (page = 1, limit = 25, business = null, filter = {}, sortData) => {
  let queryParams = {}

  if (page && limit) {
    const offset = (page - 1) * limit
    queryParams = { ...queryParams, ...{ page, limit, offset } }
  }

  if (filter) {
    const { status, search } = filter
    if (status && status !== 'All') {
      queryParams = { ...queryParams, ...{ status } }
    }

    if (search) {
      queryParams = { ...queryParams, ...{ search } }
    }
  }

  if (sortData) {
    const { field, order } = sortData
    if (field && order) {
      const ordering = order === 'asc' ? field : `-${field}`
      queryParams = { ...queryParams, ...{ ordering } }
    }
  } else {
    queryParams = { ...queryParams, ...{ ordering: '-access_code__created' } }
  }

  return buildUrl(`${API_ENDPOINT_BUSINESS_TX}/${business}/adobe-access-codes/`, {
    ...queryParams,
  })
}

export const fetchESignDataByBusinessId = (business = null, page = 1, limit = 10, filter = {}, sortData) => ({
  [CALL_API]: {
    endpoint: buildDataUrl(page, limit, business, filter, sortData),
    types: [E_SIGN_REQUEST, E_SIGN_SUCCESS, E_SIGN_FAILURE],
    method: 'GET',
    tokenType: API_JWT_TOKEN_NAME,
  },
})
